(function () {
    'use strict';
  // Perf guard: only run when explicitly enabled via ?tmqa=1 — never for real visitors
  if (location.search.indexOf('tmqa=1') === -1) return;
  var VERSION = '1.1.0';


  // Only run on collection and search pages
  var path = window.location.pathname;
  var isCollectionPage = path.indexOf('/collections/') !== -1;
  var isSearchPage = path.indexOf('/search') !== -1;
  if (!isCollectionPage && !isSearchPage) return;

  function validateTiles() {
    var tiles = document.querySelectorAll('.product-card-wrapper');
    if (!tiles.length) {
      console.warn('[TM Tile Validator v' + VERSION + '] No .product-card-wrapper elements found on this page.');
      return;
    }

    var warnings = [];
    var broken_links = [];

    tiles.forEach(function (tile, i) {
      var img = tile.querySelector('img');
      var heading = tile.querySelector('.card__heading');
      var price = tile.querySelector('.price');
      var links = tile.querySelectorAll('a[href]');

      if (!img) warnings.push('Tile ' + i + ': missing product image');
      if (!heading) warnings.push('Tile ' + i + ': missing .card__heading');
      if (!price) warnings.push('Tile ' + i + ': missing .price element');

      links.forEach(function (link) {
        var href = link.getAttribute('href');
        if (href && href.indexOf('/products/') === -1 && href.indexOf('/collections/') === -1 && href !== '#') {
          broken_links.push('Tile ' + i + ': suspicious link href="' + href + '"');
        }
      });
    });

    if (warnings.length || broken_links.length) {
      console.group('[TM Tile Validator v' + VERSION + '] Issues found on ' + tiles.length + ' tiles');
      warnings.forEach(function (w) { console.warn(w); });
      broken_links.forEach(function (l) { console.warn(l); });
      console.groupEnd();
    } else {
      console.log('[TM Tile Validator v' + VERSION + '] All ' + tiles.length + ' tiles OK on ' + path);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateTiles);
  } else {
    validateTiles();
  }

  // Re-run after AJAX grid swaps (pagination)
  var grid = document.getElementById('ProductGridContainer');
  if (grid) {
    new MutationObserver(function () { validateTiles(); })
      .observe(grid, { childList: true, subtree: false });
  }
})();
